/**
 * Bottom Navigation Component
 * Mobile-friendly navigation bar for dashboards (Parent, Child, Teacher)
 */
import React from 'react';

const BottomNavigation = ({ 
  currentPage, 
  setCurrentPage, 
  activeChild, 
  setShowSubmitWork,
  userRole, // 'parent', 'child', 'teacher'
  onBackClick, // Custom handler for Back button
  onHomeClick, // Custom handler for Home button
  onInsightsClick, // Custom handler for Insights button
  onCreateClick, // Custom handler for Create button
  onMessagesClick // Custom handler for Messages button
}) => {
  // Define nav items based on user role
  const getNavItems = () => {
    if (userRole === 'parent' && currentPage === 'child-dashboard') {
      // Child only gets Home, Upload Work
      return [
        { id: 'upload', label: 'Submit', icon: '📤' }
      ];
    }
    
    // Parent and Teacher get all items
    const sharedItems = [
      { id: 'home', label: 'Home', icon: '🏠' },
      { id: 'create', label: 'Create', icon: '📝' },
      { id: 'upload', label: 'Submit', icon: '📤' },
      { id: 'insights', label: 'Insights', icon: '📊' },
      { id: 'messages', label: 'Feedback', icon: '💬' }
    ];

    // if (onBackClick) {
    //   return [...sharedItems, { id: 'back', label: 'Back', icon: '⬅️' }];
    // }

    return sharedItems;
  };

  const navItems = getNavItems();

  const handleNavClick = (itemId) => {
    if (itemId === 'home' && onHomeClick) {
      // Use custom Home handler if provided
      onHomeClick();
    } else if (itemId === 'upload') {
      // Directly open Upload Work modal
      setShowSubmitWork('upload');
    } else if (itemId === 'insights' && onInsightsClick) {
      // Use custom Insights handler if provided
      onInsightsClick();
    } else if (itemId === 'messages') {
      // Trigger the Report Issue / Feedback flow directly when provided
      if (onMessagesClick) {
        onMessagesClick();
      } else if (setCurrentPage) {
        setCurrentPage(itemId);
      }
    } else if (itemId === 'create' && onCreateClick) {
      // Use custom Create handler if provided
      onCreateClick();
    } else if (itemId === 'back' && onBackClick) {
      onBackClick();
    }
    else {
      setCurrentPage(itemId);
    }
  };

  return (
    <>
      <div className="bottom-nav-spacer" aria-hidden="true" />
      <div className="bottom-nav fixed bottom-0 left-0 right-0 bg-white shadow-[0_-4px_12px_rgba(0,0,0,0.1)] z-40">
        <div className="max-w-md mx-auto">
          <div className="flex justify-around py-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`flex flex-col items-center py-1.5 px-2 rounded-lg transition-all ${
                  currentPage === item.id
                    ? 'text-blue-600 bg-blue-100'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-100'
                }`}
                data-testid={`nav-${item.id}`}
              >
                <div className="text-base leading-none mb-1.5">{item.icon}</div>
                <div className="text-[10px] font-semibold tracking-wide leading-tight">{item.label}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomNavigation;
